import React from 'react';
import "../style/AppPages.css";
import "../style/Retailers.css";
import { useTranslation } from 'react-i18next';
import foliesImg from '../images/stores/intérieur-folies-du-coeur.webp';

const Retailers = () => {
  const { t } = useTranslation();

  return (
    <div className="page-padding-info">
      <div>
        <div className="title-card-retailer">
            <h1 className="title-retailer-page">{t("retailers.title")}</h1>
        </div>

        {/* Container for all retailer cards */}
        <div className="retailers-line">

          {/* Retailer Card Example */}
          <div className="div-retailer-card">
            <div className="div-retailer-columns div-retailer-info-section">
              <div className="div-retailer-info">
                <label className="retailer-name">Les Folies du Coeur</label>
                <label className='retailer-info'>7580 Boul. Henri-Bourassa</label>
                <label className='retailer-info'>Québec, QC, G1H 3E6</label>
                <label className='retailer-info'>(418) 628-1000</label>
                <a href="https://lesfoliesducoeur.com/" target="_blank" rel="noopener noreferrer" className='retailer-info'>
                  www.lesfoliesducoeur.com
                </a>
                <a href="https://maps.app.goo.gl/Zzs3Y7qiA5a2onyj7" target="_blank" rel="noopener noreferrer" className='retailer-info'>
                  {t("retailers.openMaps")}
                </a>
              </div>
            </div>

            <div className="div-retailer-columns">
              <iframe
                loading="lazy"
                allowFullScreen
                src="https://www.google.com/maps/embed/v1/search?q=Les%20Folies%20du%20Coeur%20%7C%20Boutique%20%C3%A9rotique%2C%20Boulevard%20Henri-Bourassa%2C%20Qu%C3%A9bec%20City%2C%20QC%2C%20Canada&key=AIzaSyBbMPB640zwX2hxvYhp2lvBm7hy5M1bXvI"
              ></iframe>
              <img
                loading="lazy"
                alt="Les Folies du Coeur storefront"
                src={foliesImg}
              />
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Retailers;
